﻿import React from 'react';

import ButtonComponent from './Components/ButtonComponent'

import { getEpiData } from '../../Utils/epiHelpers'

//Hooks
import useScript from '../../CustomHooks/useScript';
import useInlineScript from '../../CustomHooks/useInlineScript';


const InsurelyForm = (props) => {
    const linkText = getEpiData('text', props.mountRootId) || '';
    const linkUrl = getEpiData('url', props.mountRootId) || '';
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const hasSessionId = urlParams.has('sessionId');
    let sessionId = '';

    if (hasSessionId) {
        sessionId = urlParams.get('sessionId')    
    }

    useInlineScript(`
        window.insurely = {
            config: {
                customerId: '09880d62-d835-4aa7-9c78-d1c1ee1b46bd',
                configName: 'lararforsakringar-sst-pension',
                dataAggregation: {
                    sstSessionId: '${sessionId}',
                    multiSelect: 'true',
                    legalDocuments: {
                        termsAndConditions: 'https://www.lararforsakringar.se/anvandarvillkor-pensionsinhamtning/',
                        privacyPolicy: 'https://www.lararforsakringar.se/behandling-av-personuppgifter-pensionsinhamtning/'
                    }
                },
            },
        };`
    ); 

    useScript('https://blocks.insurely.com/assets/bootstrap.js');

    return (
        <div className="insurely block-spacing">
            <iframe
              id="insurely-data-aggregation"
              title="insurely-data-aggregation"
              src="https://blocks.insurely.com/"
              sandbox="allow-scripts
                allow-same-origin
                allow-popups
                allow-forms
                allow-popups-to-escape-sandbox
                allow-top-navigation"
            />

            <ButtonComponent linkText={linkText} linkUrl={linkUrl} />
        </div>
    )
};

export default InsurelyForm;